import { render, staticRenderFns } from "./CompanyAdmin.vue?vue&type=template&id=6081bab9&scoped=true&"
import script from "./CompanyAdmin.vue?vue&type=script&lang=js&"
export * from "./CompanyAdmin.vue?vue&type=script&lang=js&"
import style0 from "./CompanyAdmin.vue?vue&type=style&index=0&id=6081bab9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6081bab9",
  null
  
)

export default component.exports